/**
 * Composant pour afficher un séparateur de section.
 * (Titre avec un trait à gauche et à droite)
 */
export const SectionDivider = ({ children }: { children: React.ReactNode }) => (
  <div className="flex items-center gap-10 my-20 mx-10">
    <div className="flex-grow border-t border-border"></div>
    <div className="whitespace-nowrap text-lg">{children}</div>
    <div className="flex-grow border-t border-border"></div>
  </div>
);
